var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.src,"height":_vm.round(_vm._height),"width":_vm.round(_vm._width),"alt":_vm._alt}})}
var staticRenderFns = []

export { render, staticRenderFns }